/* LINK UP 97 — theme.js (vanilla, ~8 Ko, chargé en defer) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches || !window.LU?.motion;
  const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });

  /* ---------- Texte découpé mot par mot ---------- */
  $$('[data-split]').forEach((el) => {
    if (el.dataset.done) return;
    el.dataset.done = 1;
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map((w, i) => `<span class="w" aria-hidden="true"><span style="--i:${i}">${w}</span></span>`).join(' ');
  });

  /* ---------- Apparition au scroll ---------- */
  const revealEls = $$('[data-reveal],[data-split]');
  if (reduce || !('IntersectionObserver' in window)) {
    revealEls.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));
  }

  /* ---------- Header : masqué en descendant, visible en remontant ---------- */
  const hdr = $('.hdr');
  if (hdr) {
    let last = 0, ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = scrollY;
        hdr.classList.toggle('is-scrolled', y > 10);
        hdr.classList.toggle('is-hidden', y > 300 && y > last && !document.body.classList.contains('lock'));
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Parallaxe légère ---------- */
  const px = $$('[data-parallax]');
  if (px.length && !reduce) {
    const run = () => {
      px.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const k = parseFloat(el.dataset.parallax) || 0.15;
        el.style.transform = `translate3d(0,${(r.top + r.height / 2 - innerHeight / 2) * -k}px,0)`;
      });
    };
    addEventListener('scroll', () => requestAnimationFrame(run), { passive: true });
    run();
  }

  /* ---------- Tiroirs (menu, panier) & recherche ---------- */
  const open = (el) => { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock'); document.body.style.overflow = 'hidden'; $('input,button,a', el.querySelector('.drawer__panel') || el)?.focus({ preventScroll: true }); };
  const close = (el) => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lock'); document.body.style.overflow = ''; };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open]');
    if (t) { const el = document.getElementById(t.dataset.open); if (el) { e.preventDefault(); open(el); if (t.dataset.open === 'Search') setTimeout(() => $('#Search input')?.focus(), 50); } }
    const c = e.target.closest('[data-close]');
    if (c) { const el = c.closest('.drawer,.search-ov'); if (el) close(el); }
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open,.search-ov.is-open').forEach(close); });

  /* ---------- Carrousels ---------- */
  $$('[data-rail]').forEach((rail) => {
    const track = $('.rail__track', rail), bar = $('.rail__progress span', rail);
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 20;
    $('[data-prev]', rail)?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    $('[data-next]', rail)?.addEventListener('click', () => track.scrollBy({ left: step() }));
    const upd = () => { if (!bar) return; const max = track.scrollWidth - track.clientWidth; const vis = track.clientWidth / track.scrollWidth; bar.style.setProperty('--p', `${Math.max(vis, max ? vis + (1 - vis) * (track.scrollLeft / max) : 1) * 100}%`); };
    track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    upd();
  });

  /* ---------- Compte à rebours ---------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const f = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let d = Math.max(0, end - Date.now()) / 1000;
      const v = [Math.floor(d / 86400), Math.floor((d % 86400) / 3600), Math.floor((d % 3600) / 60), Math.floor(d % 60)];
      $$('b', el).forEach((b, i) => (b.textContent = f(v[i])));
      if (d > 0) setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---------- Panier AJAX ---------- */
  const drawer = $('#CartDrawer');
  const useDrawer = !!drawer;
  const sections = 'cart-drawer-content';
  const renderCart = async (json) => {
    const html = json?.sections?.[sections] ?? (await (await fetch(`${location.pathname}?section_id=${sections}`)).text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawerInner');
    if (fresh && $('#CartDrawerInner')) $('#CartDrawerInner').replaceWith(fresh);
    const count = fresh?.dataset.count;
    $$('.cart-count').forEach((c) => { c.textContent = count; c.hidden = count === '0'; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
  };
  const addToCart = async (form, btn) => {
    const label = btn?.innerHTML;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = '…'; }
    try {
      const fd = new FormData(form);
      if (useDrawer) fd.append('sections', sections);
      const res = await fetch(window.LU.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const json = await res.json();
      if (!res.ok) { alertMsg(form, json.description || json.message); return; }
      if (useDrawer) { await renderCart(json); open(drawer); } else location.href = window.LU.routes.cart_url;
    } catch (e) { form.submit(); }
    finally { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; } }
  };
  const alertMsg = (form, msg) => {
    let m = $('.form-msg', form);
    if (!m) { m = document.createElement('p'); m.className = 'form-msg form-msg--err'; form.prepend(m); }
    m.textContent = msg;
  };
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-atc]');
    if (!f) return;
    e.preventDefault();
    addToCart(f, e.submitter || $('[type=submit]', f));
  });
  // Ajout rapide depuis la carte produit (taille)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-variant]');
    if (!b) return;
    e.preventDefault();
    const f = document.createElement('form');
    f.innerHTML = `<input name="id" value="${b.dataset.quickVariant}"><input name="quantity" value="1">`;
    addToCart(f, b);
  });
  // Changement de quantité dans le tiroir / page panier
  const changeLine = async (line, qty, wrap) => {
    wrap?.classList.add('is-loading');
    const res = await fetch(window.LU.routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: qty, sections }) });
    const json = await res.json();
    if ($('.tpl-cart')) { location.reload(); return; }
    await renderCart(json);
    wrap?.classList.remove('is-loading');
  };
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty]');
    if (q) {
      const box = q.closest('.qty'), input = $('input', box);
      const v = Math.max(parseInt(input.min, 10) || 0, (parseInt(input.value, 10) || 0) + parseInt(q.dataset.qty, 10));
      input.value = v;
      if (box.dataset.line) changeLine(+box.dataset.line, v, q.closest('[data-cart-wrap]'));
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(+rm.dataset.remove, 0, rm.closest('[data-cart-wrap]')); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty[data-line] input');
    if (input) changeLine(+input.closest('.qty').dataset.line, Math.max(0, parseInt(input.value, 10) || 0), input.closest('[data-cart-wrap]'));
  });

  /* ---------- Fiche produit : variantes ---------- */
  $$('[data-product]').forEach((root) => {
    const data = JSON.parse($('[data-product-json]', root)?.textContent || 'null');
    if (!data) return;
    const form = $('form[data-atc]', root), idInput = $('input[name=id]', form);
    const btn = $('[data-atc-btn]', root), priceEl = $('[data-price]', root), stockEl = $('[data-stock]', root);
    const sticky = $('.sticky-atc');
    const findVariant = () => {
      const opts = $$('.opt', root).map((fs) => $('input:checked', fs)?.value);
      return data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    };
    const markAvail = () => {
      const sets = $$('.opt', root);
      sets.forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const sel = sets.map((s) => $('input:checked', s)?.value); sel[idx] = inp.value;
          const ok = data.variants.some((v) => v.available && v.options.every((o, i) => i === idx ? o === inp.value : (i < idx ? o === sel[i] : true)));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    };
    const update = () => {
      const v = findVariant();
      markAvail();
      if (!v) { btn.setAttribute('disabled', ''); btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (priceEl) priceEl.innerHTML = (v.compare_at_price > v.price ? `<span class="price__now">${money(v.price)}</span> <s>${money(v.compare_at_price)}</s>` : `<span class="price__now">${money(v.price)}</span>`);
      priceEl?.classList.toggle('price--sale', v.compare_at_price > v.price);
      window.LU.updateAlma(root, v.price);
      if (v.available) { btn.removeAttribute('disabled'); btn.innerHTML = btn.dataset.add; } else { btn.setAttribute('disabled', ''); btn.textContent = btn.dataset.soldout; }
      if (stockEl) {
        const q = (data.inventory || {})[v.id];
        stockEl.className = 'stock' + (!v.available ? ' stock--out' : q !== undefined && q > 0 && q <= 5 ? ' stock--low' : '');
        stockEl.textContent = !v.available ? stockEl.dataset.out : q !== undefined && q > 0 && q <= 5 ? stockEl.dataset.low.replace('[n]', q) : stockEl.dataset.in;
      }
      if (v.featured_media) { const fig = $(`[data-media-id="${v.featured_media.id}"]`, root); if (fig && innerWidth < 750) fig.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }
      if (sticky) { const sb = $('button', sticky); sb.disabled = !v.available; $('[data-sticky-price]', sticky).textContent = money(v.price); }
    };
    root.addEventListener('change', (e) => { if (e.target.closest('.opt')) update(); });
    markAvail();
    if (sticky && btn) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
      $('button', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  });

  /* ---------- Alma ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.alma__plan');
    if (!b) return;
    b.parentElement.querySelectorAll('.alma__plan').forEach((x) => x.classList.toggle('is-active', x === b));
  });
  window.LU.updateAlma = (root, cents) => {
    $$('[data-alma]', root).forEach((a) => {
      const min = +a.dataset.min, max = +a.dataset.max, total = cents + (+a.dataset.base || 0);
      const ok = total >= min && cents <= max;
      a.classList.toggle('is-locked', !ok);
      const plans = $('[data-alma-plans]', a); if (plans) plans.hidden = !ok;
      const bar = $('[data-alma-bar]', a);
      if (bar) { bar.hidden = ok; $('span', bar).style.width = (min ? Math.min(100, total * 100 / min) : 100) + '%'; }
      const t = $('[data-alma-text]', a);
      if (t) t.textContent = ok ? a.dataset.ok : a.dataset.ko.replace('[reste]', money(Math.max(0, min - total)));
      $$('.alma__plan', a).forEach((p) => { $('[data-each]', p).textContent = money(Math.floor(cents / +p.dataset.n)); });
    });
  };

  /* ---------- Filtres de collection ---------- */
  $$('[data-facets-form]').forEach((f) => {
    f.addEventListener('change', () => {
      const q = new URLSearchParams(new FormData(f));
      [...q.keys()].forEach((k) => { if (!q.get(k)) q.delete(k); });
      location.search = q.toString();
    });
  });
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));
  $('[data-toggle-facets]')?.addEventListener('click', () => $('.facets')?.classList.toggle('is-open'));

  /* ---------- Préchargement au survol (navigation quasi instantanée) ---------- */
  if ('connection' in navigator ? !navigator.connection.saveData : true) {
    const done = new Set();
    document.addEventListener('pointerover', (e) => {
      const a = e.target.closest('a[href^="/"]');
      if (!a || done.has(a.href) || a.href.includes('/cart') || a.href.includes('/account') || a.hasAttribute('download')) return;
      done.add(a.href);
      const l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
    }, { passive: true });
  }
})();
